export default "__VITE_ASSET__BGcBEsOq__"